// i18next initialization for the operator terminal.
//
// Catalogs are bundled statically — zero network on locale switch. Backends
// would force a fetch round-trip on every language flip, which we explicitly
// don't want (Iron Rule #12: no LLM calls at render time; here we also don't
// want any network calls at render time for translations).
//
// EN is canonical: every key exists with its source-of-truth string. FR/ZH/HE
// are professional translations bundled in `./locales/{lang}.json`. Locales
// listed in `SUPPORTED_LOCALES` that don't yet have a catalog (es/ar/de/pt/ja)
// fall back through to EN automatically — they will be added in subsequent
// passes.
//
// The active language is owned by `useLocale()` in `./locale.tsx` — this
// module just listens for changes and forwards them to i18next so there's a
// single source of truth.

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import fr from '../locales/fr.json';
import he from '../locales/he.json';
import zh from '../locales/zh.json';

void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    zh: { translation: zh },
    he: { translation: he },
  },
  lng: 'en',
  fallbackLng: 'en',
  // We trust our own catalogs; React already escapes.
  interpolation: { escapeValue: false },
  // Production: keep console quiet.
  debug: false,
  // Don't crash a render on a missing key — fall back to the key itself or
  // the EN catalog.
  returnNull: false,
});

export default i18next;
